// The Order Status file on Overseas Sales (OrderStatusUpload.jsx, OrderStatusData.jsx — Max 02/11: the upload button out
// on the report, a Data table read-only while the daily file is the source).
const en = {
  upload: 'Upload Order Status',
  reading: 'Reading the file…',
  readingLong: 'Reading the Order Status master — about half a minute for a 20 MB file.',
  uploaded: 'Order Status read: {{n}} rows, S/D {{from}} → {{to}}.',
  tab: 'Order Status data',
  fileLine: 'File: {{file}} · updated {{at}} by {{by}} · {{n}} rows',
  byFeed: 'the daily feed',
  noFile: 'No Order Status file uploaded yet.',
  search: 'Search',
  searchPh: 'PO, buyer, SAP code, item, model, colour…',
  clear: 'Clear',
  excel: 'Excel',
  shown: '{{n}} rows · Q\'ty {{q}}',
  loading: 'Loading…',
  noRows: 'No rows match these filters.',
};

const ko = {
  upload: 'Order Status 업로드',
  reading: '파일을 읽는 중…',
  readingLong: 'Order Status 마스터를 읽는 중입니다 — 20 MB 파일은 약 30초 걸립니다.',
  uploaded: 'Order Status 읽기 완료: {{n}}행, S/D {{from}} → {{to}}.',
  tab: 'Order Status 데이터',
  fileLine: '파일: {{file}} · {{at}} {{by}} 업데이트 · {{n}}행',
  byFeed: '매일 자동 업로드',
  noFile: '아직 업로드된 Order Status 파일이 없습니다.',
  search: '검색',
  searchPh: 'PO, 바이어, SAP 코드, 품목, 모델, 색상…',
  clear: '초기화',
  excel: 'Excel',
  shown: '{{n}}행 · 수량 {{q}}',
  loading: '불러오는 중…',
  noRows: '조건에 맞는 행이 없습니다.',
};

const vi = {
  upload: 'Tải lên Order Status',
  reading: 'Đang đọc file…',
  readingLong: 'Đang đọc file Order Status master — file 20 MB mất khoảng nửa phút.',
  uploaded: 'Đã đọc Order Status: {{n}} dòng, S/D {{from}} → {{to}}.',
  tab: 'Dữ liệu Order Status',
  fileLine: 'File: {{file}} · cập nhật {{at}} bởi {{by}} · {{n}} dòng',
  byFeed: 'nạp tự động hằng ngày',
  noFile: 'Chưa có file Order Status nào được tải lên.',
  search: 'Tìm',
  searchPh: 'PO, buyer, mã SAP, item, model, màu…',
  clear: 'Xóa lọc',
  excel: 'Excel',
  shown: '{{n}} dòng · SL {{q}}',
  loading: 'Đang tải…',
  noRows: 'Không có dòng nào khớp bộ lọc.',
};

const zh = {
  upload: '上传 Order Status',
  reading: '正在读取文件…',
  readingLong: '正在读取 Order Status 主表 — 20 MB 的文件约需半分钟。',
  uploaded: '已读取 Order Status：{{n}} 行，S/D {{from}} → {{to}}。',
  tab: 'Order Status 数据',
  fileLine: '文件：{{file}} · {{at}} 由 {{by}} 更新 · {{n}} 行',
  byFeed: '每日自动上传',
  noFile: '尚未上传 Order Status 文件。',
  search: '搜索',
  searchPh: 'PO、买家、SAP 代码、品项、型号、颜色…',
  clear: '清除',
  excel: 'Excel',
  shown: '{{n}} 行 · 数量 {{q}}',
  loading: '加载中…',
  noRows: '没有符合筛选条件的行。',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "upload": "Importer l'Order Status",
  "reading": "Lecture du fichier…",
  "readingLong": "Lecture du fichier maître Order Status — environ une demi-minute pour un fichier de 20 Mo.",
  "uploaded": "Order Status lu : {{n}} lignes, S/D {{from}} → {{to}}.",
  "tab": "Données Order Status",
  "fileLine": "Fichier : {{file}} · mis à jour le {{at}} par {{by}} · {{n}} lignes",
  "byFeed": "le flux quotidien",
  "noFile": "Aucun fichier Order Status importé pour le moment.",
  "search": "Rechercher",
  "searchPh": "PO, acheteur, code SAP, article, modèle, couleur…",
  "clear": "Effacer",
  "excel": "Excel",
  "shown": "{{n}} lignes · Q'ty {{q}}",
  "loading": "Chargement…",
  "noRows": "Aucune ligne ne correspond à ces filtres."
};
const ja = {
  "upload": "Order Status をアップロード",
  "reading": "ファイルを読み込み中…",
  "readingLong": "Order Status マスターを読み込み中です — 20 MB のファイルで約30秒かかります。",
  "uploaded": "Order Status を読み込みました：{{n}} 行、S/D {{from}} → {{to}}。",
  "tab": "Order Status データ",
  "fileLine": "ファイル：{{file}} · {{at}} に {{by}} が更新 · {{n}} 行",
  "byFeed": "日次フィード",
  "noFile": "Order Status ファイルはまだアップロードされていません。",
  "search": "検索",
  "searchPh": "PO、バイヤー、SAP コード、アイテム、モデル、カラー…",
  "clear": "クリア",
  "excel": "Excel",
  "shown": "{{n}} 行 · Q'ty {{q}}",
  "loading": "読み込み中…",
  "noRows": "これらの条件に一致する行はありません。"
};

const dictionary = { ns: 'xOrderStatus', en, ko, vi, zh, fr, ja };

export default dictionary;
